export default "__VITE_ASSET__783f0e1d__"